import { useCallback, useState } from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';

import { useListeningSettingsStore } from 'modules/listening/features/settings/settingsStore';
import { md5 } from 'utils/md5';

import { useAuthStore } from '../store/authStore';

export type UserAvatarImage = {
  avatarImageSrc: string | undefined;
  avatarImageOnError: () => void;
};

export const useUserAvatarImage = (): UserAvatarImage => {
  const [src, setSrc] = useState<string | undefined>(undefined);
  const currentUser = useAuthStore(state => state.user);
  const isDarkMode = useListeningSettingsStore(s => s.darkMode);
  const md5Email = useMemo(() => md5(currentUser?.email || ''), [currentUser]);

  const profileAvatarFallback = useMemo(() => (isDarkMode ? '/images/user-profile/avatar-dark.png' : '/images/user-profile/avatar-light.png'), [isDarkMode]);

  useEffect(() => {
    if (currentUser?.email && currentUser?.photoURL) {
      setSrc(currentUser.photoURL);
    } else {
      setSrc(profileAvatarFallback);
    }
  }, [currentUser, md5Email, profileAvatarFallback]);

  const onError = useCallback(() => {
    setSrc(profileAvatarFallback);
  }, [profileAvatarFallback]);

  return { avatarImageSrc: src, avatarImageOnError: onError };
};
